import React from "react";
import { useNavigate } from "react-router-dom";
// import mui icons
import { PermIdentityOutlined, ArrowForwardOutlined, FavoriteBorderOutlined } from "@mui/icons-material";
import { borderBottom, borderRadius, textAlign } from "@mui/system";
import { verifyBeforeUpdateEmail } from "firebase/auth";

const MyAccountComponent = ({ toggleMenu }) => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    toggleMenu(); // Close the drawer
    navigate(path); // Navigate to the specified path
  };

  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.title }}>My Account</div>
      <div style={{ ...styles.myProfile.container }} onClick={() => handleNavigation("/useraccount")}>
        <div style={{ ...styles.myProfile.text }}>
          <PermIdentityOutlined style={{ marginRight: 10 }} />
          Profile
        </div>
        <div style={{ ...styles.myProfile.arrow }}>
          <ArrowForwardOutlined />
        </div>
      </div>
      <div style={{ ...styles.myProfileOptions.container }}>
        <div style={{ ...styles.myProfileOptions.box }} onClick={() => handleNavigation("/favorites")}>
          <div style={{ height: 20, marginBottom: 3 }}>
            <FavoriteBorderOutlined style={{}} />
          </div>
          <div>Favorites</div>
        </div>
        <div style={{ ...styles.myProfileOptions.box }} onClick={() => handleNavigation("/wallet")}>
          <div style={{ height: 20, marginBottom: 3 }}>
            <img src="/images/svg/Wallet.svg" alt="Fullproof" style={{ height: 20 }} />
          </div>
          <div>Wallet</div>
        </div>
        <div style={{ ...styles.myProfileOptions.box }} onClick={() => handleNavigation("/orderhistory")}>
          <div style={{ height: 20, marginBottom: 3 }}>
            <img src="/images/svg/Orders.png" alt="Fullproof" style={{ height: 20 }} />
          </div>
          <div>Orders</div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 0",
    borderBottom: "3px solid #D9D9D9",
  },
  title: {
    fontSize: "1.3rem",
    fontWeight: "600",
    color: "#000",
    textAlign: "left",
    marginBottom: 15,
  },
  //
  myProfile: {
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 15px",
      cursor: "pointer",
      background: "#F5F5F5",
      borderRadius: 8,
    },
    text: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      fontSize: "1rem",
      fontWeight: "500",
      color: "#000",
    },
    arrow: {
      fontSize: "1rem",
      fontWeight: "500",
      color: "#000",
    },
  },
  //
  myProfileOptions: {
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      gap: 15,
      marginTop: 15,
    },
    box: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      alignItems: "center",
      fontSize: "1rem",
      fontWeight: "500",
      color: "#000",
      background: "#F5F5F5",
      padding: "12px 0",
      justifyContent: "center",
      borderRadius: 8,
      cursor: "pointer",
    },
  },
};

export default MyAccountComponent;
